/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import PanCardUpload from "./UploadDocument.container";

export default PanCardUpload;